module.exports = __webpack_public_path__ + "static/media/crown-icon.73c0336b.png";